module.exports = __webpack_public_path__ + "static/media/jackets.497267a9.jpeg";